'use strict';

module.exports = require('./lib/ReactTestUtils');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/test-utils.js
// module id = 387
// module chunks = 0